module.exports = __webpack_public_path__ + "img/reward-btn.b6741f46.png";